import PropTypes from "prop-types";
import React from "react";
import { formatPackageMoney } from "./packageBalanceContract";

const eventLabel = (type) => ({
  debit: "Credit used",
  reversal: "Credit restored",
  adjustment: "Balance adjustment",
  legacy_unattributed: "Legacy usage not attributable",
}[type] || "Credit event");

const PackageBalanceDetail = ({ packageBalance, usagePage, loading = false, error = "", onClose, onLoadMore }) => {
  const hasLegacyGap = packageBalance.unattributedMinor > 0 || usagePage.data.some((event) => event.type === "legacy_unattributed");
  return (
    <div className="drawer addnote-drawer p-0 open" role="dialog" aria-label={`Credit usage for ${packageBalance.name}`}>
      <div className="drawer-wrp position-relative">
        <div className="drawer-header">
          <h2 className="mt-3 ms-3 pe-md-5 pe-3">{packageBalance.name} credit usage</h2>
          <button type="button" className="close mt-2 me-4 btn btn-link" aria-label="Close package credit usage" onClick={onClose}>×</button>
        </div>
        <div className="drawer-body px-4">
          {hasLegacyGap && (
            <div className="alert alert-warning" role="alert">
              Some historical credit cannot be matched to a specific service, sale or appointment. No attribution has been guessed.
            </div>
          )}
          {error && <div className="alert alert-danger">{error}</div>}
          {usagePage.data.map((event) => (
            <article className="border rounded p-3 mb-2" key={event.id}>
              <div className="d-flex justify-content-between fw-semibold">
                <span>{eventLabel(event.type)}</span>
                <span>{formatPackageMoney(event.amount)}</span>
              </div>
              {event.service && <div>{event.service.name}</div>}
              {event.sale && (
                <div>
                  <span>{event.sale.invoiceNumber || `Sale #${event.sale.id}`}</span>
                  {event.sale.status && <span>{` · ${event.sale.status}`}</span>}
                </div>
              )}
              {event.appointment
                ? <div>{`Appointment #${event.appointment.id}${event.appointment.status ? ` · ${event.appointment.status}` : ""}`}</div>
                : event.type !== "legacy_unattributed" && <div className="text-muted">No appointment linked</div>}
              {event.occurredAt && <div className="small text-muted">{event.occurredAt}</div>}
            </article>
          ))}
          {!loading && usagePage.data.length === 0 && !error && <div className="text-muted">No credit usage recorded.</div>}
          {loading && <div className="text-muted">Loading credit usage…</div>}
          {usagePage.nextPageUrl && !loading && (
            <button type="button" className="btn btn-primary mt-2" aria-label="Load more credit usage" onClick={() => onLoadMore(usagePage.nextPageUrl)}>
              Load more
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

PackageBalanceDetail.propTypes = {
  packageBalance: PropTypes.object,
  usagePage: PropTypes.object,
  loading: PropTypes.bool,
  error: PropTypes.string,
  onClose: PropTypes.func,
  onLoadMore: PropTypes.func,
};

export default PackageBalanceDetail;
